import GoogleLocationTypeahead from '../../GoogleLocationTypeahead';
import { Field as FormikField, FieldProps } from 'formik';
import React, { FC } from 'react';

type Props = {
  name: string;
  label: string;
};

const WeddingLocationField: FC<Props> = ({ name, label }) => {
  return (
    <FormikField name={name}>
      {({ field: { name: fieldName, value: fieldValue }, form: { setFieldValue } }: FieldProps) => (
        <GoogleLocationTypeahead
          name={fieldName}
          label={label}
          defaultInputValue={fieldValue}
          onInputChange={(value: string) => {
            !value.length && setFieldValue(fieldName, '');
          }}
          onChange={(value: string) => {
            setFieldValue(fieldName, value);
          }}
          data-testid="wedding-location"
        />
      )}
    </FormikField>
  );
};

export default WeddingLocationField;
